import React, { useEffect, useRef, useState } from 'react';
import { useInView } from '~/hooks/useInView';

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
}

export const LazyImage: React.FC<ImageProps> = ({ src, alt, ...props }) => {
  const placeholder =
    'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
  const [source, setSource] = useState(placeholder || '');
  const ref = useRef<HTMLImageElement>(null);

  const [intersected, cancel] = useInView(ref, { threshold: 0.5 });

  useEffect(() => {
    if (source === src) {
      return;
    }

    if (!intersected || source !== placeholder) {
      // Exit if not intersected or source is already set
      return;
    }
    const img = new Image();
    img.src = src;
    img.style.objectFit = 'cover';
    img.onload = () => {
      setSource(src);
      cancel(); // Cancel observer after image is loaded
    };
  }, [intersected, source, placeholder, src, cancel]);

  return (
    <img
      src={source || placeholder}
      loading="lazy"
      alt={alt}
      {...props}
      ref={ref}
      style={{ objectFit: 'contain' }}
    />
  );
};
